module.exports = __webpack_public_path__ + "img/Bodice-Front-B10-Da-Eb.aefe076d.png";